import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Boutton from '../Boutton/Boutton';
import './Card2.css';

const stockColors = {
  'En stock ': '#10b981',
  'En arrivage': '#6366f1',
  'Sur commande': '#3b82f6',
  'Hors stock': '#ef4444',
};

const mediaVariants = {
  rest: { y: 0, boxShadow: '0 0px 0px rgba(43, 36, 32, 0)' },
  hover: { y: -6, boxShadow: '0 26px 44px -18px rgba(43, 36, 32, 0.45)' },
};

const imageVariants = {
  rest: { scale: 1 },
  hover: { scale: 1.07 },
};

const tagVariants = {
  rest: { rotate: -7, scale: 1 },
  hover: { rotate: 0, scale: 1.06 },
};

export const Card2 = (props) => {
  const [quantite] = useState(1);
  const detailHref = `/${props.nom}/details/${props.id}`;
  const stockColor = stockColors[props.disponibilité] || '#6b7280';

  return (
    <motion.div
      className="col-lg-3 col-md-4 col-6 mb-4"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="hd-card3">
        <Link className="hd-card3-media-link" to={detailHref}>
          <motion.div
            className="hd-card3-media"
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={mediaVariants}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            <motion.img
              src={props.image}
              alt={props.titre}
              className="hd-card3-image"
              variants={imageVariants}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            />

            {props.disponibilité && (
              <span className="hd-card3-stock">
                <span className="hd-card3-stock-dot" style={{ backgroundColor: stockColor }} />
                {props.disponibilité.trim()}
              </span>
            )}

            <motion.span
              className="hd-card3-tag"
              variants={tagVariants}
              transition={{ type: 'spring', stiffness: 320, damping: 16 }}
            >
              {props.prix} DT
            </motion.span>
          </motion.div>
        </Link>

        <div className="hd-card3-info">
          <Link to={detailHref} className="hd-card3-title-link">
            {props.reference && <span className="hd-card3-ref">Réf. {props.reference}</span>}
            <h3 className="hd-card3-title">{props.titre}</h3>
          </Link>

          <div className="hd-card3-cta">
            <Boutton item={props} price={props.prix} quantite={quantite} />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Card2;
